import { css } from '@emotion/react';
import type { Theme } from '@emotion/react';

import { breakpoint } from '@twistopayments/design-system/styles';

export const box = (theme: Theme) => css`
  display: flex;
  width: 100%;
  align-items: center;
  border-bottom: 1px solid ${theme.palette.ghost.mediumContrast};

  box-sizing: content-box;
  min-height: 22px;
  padding: 0 0 ${theme.spacing[4]};

  ${breakpoint.up('md')} {
    min-height: 24px;
    padding: ${theme.spacing[4]} 0 ${theme.spacing[8]};
  }
`;

export const focused = (theme: Theme) => css`
  border-bottom-color: ${theme.palette.secondary.mainContrast};
  box-shadow: 0 1px 0 0 ${theme.palette.secondary.mainContrast};
`;

export const error = (theme: Theme) => css`
  border-bottom-color: ${theme.palette.error.main};
  box-shadow: 0 1px 0 0 ${theme.palette.error.main};
`;
